"use strict";

var _regeneratorRuntime = require("@babel/runtime/regenerator");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var Options = require("./options");

var $Refs = require("./refs");

var parse = require("./parse");

var normalizeArgs = require("./normalize-args");

var resolveExternal = require("./resolve-external");

var bundle = require("./bundle");

var dereference = require("./dereference");

var url = require("./util/url");

var maybe = require("call-me-maybe");

var _require = require("ono"),
    ono = _require.ono;

module.exports = $RefParser;
module.exports.YAML = require("./util/yaml");
/**
 * This class parses a JSON schema, builds a map of its JSON references and their resolved values,
 * and provides methods for traversing, manipulating, and dereferencing those references.
 *
 * @constructor
 */

function $RefParser() {
  /**
   * The parsed (and possibly dereferenced) JSON schema object
   *
   * @type {object}
   * @readonly
   */
  this.schema = null;
  /**
   * The resolved JSON references
   *
   * @type {$Refs}
   * @readonly
   */

  this.$refs = new $Refs();
}
/**
 * Parses the given JSON schema.
 * This method does not resolve any JSON references.
 * It just reads a single file in JSON or YAML format, and parse it as a JavaScript object.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed
 * @param {function} [callback] - An error-first callback. The second parameter is the parsed JSON schema object.
 * @returns {Promise} - The returned promise resolves with the parsed JSON schema object.
 */


$RefParser.parse = function (path, schema, options, callback) {
  var Class = this; // eslint-disable-line consistent-this

  var instance = new Class();
  return instance.parse.apply(instance, arguments);
};
/**
 * Parses the given JSON schema.
 * This method does not resolve any JSON references.
 * It just reads a single file in JSON or YAML format, and parse it as a JavaScript object.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed
 * @param {function} [callback] - An error-first callback. The second parameter is the parsed JSON schema object.
 * @returns {Promise} - The returned promise resolves with the parsed JSON schema object.
 */


$RefParser.prototype.parse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, schema, options, callback) {
    var args,
        promise,
        err,
        pathType,
        $ref,
        me,
        result,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            args = normalizeArgs(_args);

            if (!(!args.path && !args.schema)) {
              _context.next = 4;
              break;
            }

            err = ono("Expected a file path, URL, or object. Got ".concat(args.path || args.schema));
            return _context.abrupt("return", maybe(args.callback, Promise.reject(err)));

          case 4:
            // Reset everything
            this.schema = null;
            this.$refs = new $Refs(); // If the path is a filesystem path, then convert it to a URL.
            // NOTE: According to the JSON Reference spec, these should already be URLs,
            // but, in practice, many people use local filesystem paths instead.
            // So we're being generous here and doing the conversion automatically.
            // This is not intended to be a 100% bulletproof solution.
            // If it doesn't work for your use-case, then use a URL instead.

            pathType = "http";

            if (url.isFileSystemPath(args.path)) {
              args.path = url.fromFileSystemPath(args.path);
              pathType = "file";
            } // Resolve the absolute path of the schema


            args.path = url.resolve(url.cwd(), args.path);

            if (args.schema && _typeof(args.schema) === "object") {
              // A schema object was passed-in.
              // So immediately add a new $Ref with the schema object as its value
              $ref = this.$refs._add(args.path);
              $ref.value = args.schema;
              $ref.pathType = pathType;
              promise = Promise.resolve(args.schema);
            } else {
              // Parse the schema file/url
              promise = parse(args.path, this.$refs, args.options);
            }

            me = this;
            _context.prev = 11;
            _context.next = 14;
            return promise;

          case 14:
            result = _context.sent;

            if (!(!result || _typeof(result) !== "object" || Buffer.isBuffer(result))) {
              _context.next = 19;
              break;
            }

            throw ono.syntax("\"".concat(me.$refs._root$Ref.path || result, "\" is not a valid JSON Schema"));

          case 19:
            me.schema = result;
            return _context.abrupt("return", maybe(args.callback, Promise.resolve(me.schema)));

          case 21:
            _context.next = 26;
            break;

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](11);
            return _context.abrupt("return", maybe(args.callback, Promise.reject(_context.t0)));

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[11, 23]]);
  }));

  return function (_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Parses the given JSON schema and resolves any JSON references, including references in
 * externally-referenced files.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed and resolved
 * @param {function} [callback]
 * - An error-first callback. The second parameter is a {@link $Refs} object containing the resolved JSON references
 *
 * @returns {Promise}
 * The returned promise resolves with a {@link $Refs} object containing the resolved JSON references
 */


$RefParser.resolve = function (path, schema, options, callback) {
  var Class = this; // eslint-disable-line consistent-this

  var instance = new Class();
  return instance.resolve.apply(instance, arguments);
};
/**
 * Parses the given JSON schema and resolves any JSON references, including references in
 * externally-referenced files.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed and resolved
 * @param {function} [callback]
 * - An error-first callback. The second parameter is a {@link $Refs} object containing the resolved JSON references
 *
 * @returns {Promise}
 * The returned promise resolves with a {@link $Refs} object containing the resolved JSON references
 */


$RefParser.prototype.resolve = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, schema, options, callback) {
    var me,
        args,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            me = this;
            args = normalizeArgs(_args2);
            _context2.prev = 2;
            _context2.next = 5;
            return this.parse(args.path, args.schema, args.options);

          case 5:
            _context2.next = 7;
            return resolveExternal(me, args.options);

          case 7:
            return _context2.abrupt("return", maybe(args.callback, Promise.resolve(me.$refs)));

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", maybe(args.callback, Promise.reject(_context2.t0)));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[2, 10]]);
  }));

  return function (_x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Parses the given JSON schema, resolves any JSON references, and bundles all external references
 * into the main JSON schema. This produces a JSON schema that only has *internal* references,
 * not any *external* references.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
 * @param {function} [callback] - An error-first callback. The second parameter is the bundled JSON schema object
 * @returns {Promise} - The returned promise resolves with the bundled JSON schema object.
 */


$RefParser.bundle = function (path, schema, options, callback) {
  var Class = this; // eslint-disable-line consistent-this

  var instance = new Class();
  return instance.bundle.apply(instance, arguments);
};
/**
 * Parses the given JSON schema, resolves any JSON references, and bundles all external references
 * into the main JSON schema. This produces a JSON schema that only has *internal* references,
 * not any *external* references.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
 * @param {function} [callback] - An error-first callback. The second parameter is the bundled JSON schema object
 * @returns {Promise} - The returned promise resolves with the bundled JSON schema object.
 */


$RefParser.prototype.bundle = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path, schema, options, callback) {
    var me,
        args,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            me = this;
            args = normalizeArgs(_args3);
            _context3.prev = 2;
            _context3.next = 5;
            return this.resolve(args.path, args.schema, args.options);

          case 5:
            bundle(me, args.options);
            return _context3.abrupt("return", maybe(args.callback, Promise.resolve(me.schema)));

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", maybe(args.callback, Promise.reject(_context3.t0)));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[2, 9]]);
  }));

  return function (_x9, _x10, _x11, _x12) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Parses the given JSON schema, resolves any JSON references, and dereferences the JSON schema.
 * That is, all JSON references are replaced with their resolved values.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
 * @param {function} [callback] - An error-first callback. The second parameter is the dereferenced JSON schema object
 * @returns {Promise} - The returned promise resolves with the dereferenced JSON schema object.
 */


$RefParser.dereference = function (path, schema, options, callback) {
  var Class = this; // eslint-disable-line consistent-this

  var instance = new Class();
  return instance.dereference.apply(instance, arguments);
};
/**
 * Parses the given JSON schema, resolves any JSON references, and dereferences the JSON schema.
 * That is, all JSON references are replaced with their resolved values.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
 * @param {function} [callback] - An error-first callback. The second parameter is the dereferenced JSON schema object
 * @returns {Promise} - The returned promise resolves with the dereferenced JSON schema object.
 */


$RefParser.prototype.dereference = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path, schema, options, callback) {
    var me,
        args,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            me = this;
            args = normalizeArgs(_args4);
            _context4.prev = 2;
            _context4.next = 5;
            return this.resolve(args.path, args.schema, args.options);

          case 5:
            dereference(me, args.options);
            return _context4.abrupt("return", maybe(args.callback, Promise.resolve(me.schema)));

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](2);
            return _context4.abrupt("return", maybe(args.callback, Promise.reject(_context4.t0)));

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[2, 9]]);
  }));

  return function (_x13, _x14, _x15, _x16) {
    return _ref4.apply(this, arguments);
  };
}();